export type MovieType = "movie" | "tv";

export interface Movie {
  id: string;
  title: string;
  englishTitle: string;
  type: MovieType;
  genres: string[];
  region: string;
  year: number;
  rating: number;
  duration: string;
  director: string;
  cast: string[];
  synopsis: string;
  poster: string;
  backdrop: string;
  featured: boolean;
  popularity: number;
}

export const movies: Movie[] = [
  {
    id: "deep-sea-echo",
    title: "深海回声",
    englishTitle: "Deep Sea Echo",
    type: "movie",
    genres: ["科幻", "悬疑"],
    region: "中国",
    year: 2025,
    rating: 8.7,
    duration: "132 分钟",
    director: "程砚舟",
    cast: ["林未舟", "苏晚", "周敬川"],
    synopsis:
      "一支深海科考队在马里亚纳海沟执行例行探测时，捕捉到一段不属于任何已知海洋生物的低频信号。随着信号重复出现，队员们的记忆开始互相渗透，有人看见了从未经历过的童年，有人听见了早已离世的亲人呼唤。潜艇不断下潜，真相与幻觉的边界被一点点磨平，队长必须在氧气耗尽之前，决定是带着答案返回海面，还是永远留在那片没有人回来过的深渊里。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20poster%20of%20a%20lone%20deep%20sea%20submersible%20descending%20into%20a%20glowing%20blue%20ocean%20trench%20with%20dramatic%20light%20rays%20from%20above%20and%20dark%20moody%20water%20textures%20minimal%20elegant%20composition%20high%20detail%20dramatic%20lighting&width=600&height=900&seq=poster-deepsea-01&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20underwater%20scene%20of%20a%20research%20submarine%20surrounded%20by%20deep%20navy%20water%20with%20faint%20cyan%20glow%20and%20floating%20particles%20atmospheric%20sci-fi%20film%20still%20moody%20dark%20tones%20high%20detail&width=1600&height=900&seq=backdrop-deepsea-01&orientation=landscape",
    featured: true,
    popularity: 98,
  },
  {
    id: "long-night-ending",
    title: "长夜将尽",
    englishTitle: "Before the Dawn",
    type: "movie",
    genres: ["犯罪", "剧情"],
    region: "中国",
    year: 2024,
    rating: 8.4,
    duration: "118 分钟",
    director: "许望津",
    cast: ["张予行", "白露", "陈砚"],
    synopsis:
      "北方小城连续发生三起入室案，作案手法干净得不像新手。退休刑警老魏被请回局里帮忙，却发现线索指向二十年前一桩没有结案的旧事。在零下二十度的长夜里，他一边追查嫌疑人，一边和自己的愧疚对峙，直到天亮前的那一刻，他才明白有些真相并不需要被原谅。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20crime%20thriller%20poster%20of%20a%20lonely%20detective%20silhouette%20standing%20in%20a%20snowy%20northern%20town%20at%20night%20under%20streetlights%20deep%20navy%20tones%20with%20warm%20amber%20highlights%20minimal%20high%20contrast%20film%20grain&width=600&height=900&seq=poster-longnight-02&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Moody%20night%20cityscape%20of%20a%20small%20snow%20covered%20northern%20town%20with%20glowing%20streetlights%20and%20blue%20fog%20cinematic%20crime%20film%20still%20wide%20angle%20dark%20atmospheric&width=1600&height=900&seq=backdrop-longnight-02&orientation=landscape",
    featured: false,
    popularity: 84,
  },
  {
    id: "neon-manhunt",
    title: "霓虹追凶",
    englishTitle: "Neon Chase",
    type: "movie",
    genres: ["动作", "犯罪"],
    region: "中国香港",
    year: 2025,
    rating: 8.1,
    duration: "106 分钟",
    director: "麦嘉禾",
    cast: ["郑昱", "何曼宁", "罗子谦"],
    synopsis:
      "重案组警长在一次扫毒行动中失去搭档，唯一的线索是一段被删掉的监控。为了找回画面，他钻进了这座城市最深的霓虹背面，与线人、走私客和旧日兄弟周旋。四十八小时之后，他要面对的不只是凶手，还有自己亲手写下的那份报告。",
    poster:
      "https://readdy.ai/api/search-image?query=Neon%20soaked%20Hong%20Kong%20action%20movie%20poster%20with%20a%20lone%20running%20figure%20between%20tall%20buildings%20cyan%20and%20deep%20blue%20light%20reflections%20on%20wet%20pavement%20cinematic%20high%20contrast%20dramatic%20composition&width=600&height=900&seq=poster-neonmanhunt-03&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Rainy%20neon%20street%20at%20night%20with%20reflective%20asphalt%20towering%20city%20blocks%20and%20electric%20cyan%20signage%20cinematic%20action%20film%20still%20wide%20shot%20moody%20dark%20tones&width=1600&height=900&seq=backdrop-neonmanhunt-03&orientation=landscape",
    featured: true,
    popularity: 91,
  },
  {
    id: "spring-letter",
    title: "春日信笺",
    englishTitle: "Letters in Spring",
    type: "movie",
    genres: ["爱情", "剧情"],
    region: "日本",
    year: 2023,
    rating: 8.9,
    duration: "124 分钟",
    director: "小林紬",
    cast: ["佐仓千寻", "松田悠真", "高桥澪"],
    synopsis:
      "海边小镇的旧邮局要拆了，管理员在阁楼里发现一箱从未寄出的信，收件人都是同一个名字。她循着地址找到那位已经白了头的老人，一段关于等待、误会与春天的往事被重新拆封。信纸上没有一句激烈的告白，却把整个人生都写完了。",
    poster:
      "https://readdy.ai/api/search-image?query=Soft%20romantic%20Japanese%20film%20poster%20of%20a%20young%20woman%20holding%20old%20letters%20by%20a%20seaside%20window%20with%20cherry%20blossoms%20and%20gentle%20sunlight%20muted%20warm%20pastel%20tones%20minimal%20elegant%20composition%20shallow%20depth%20of%20field&width=600&height=900&seq=poster-springletter-04&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Quiet%20Japanese%20seaside%20town%20in%20spring%20with%20cherry%20blossom%20trees%20and%20a%20small%20old%20post%20office%20by%20the%20water%20soft%20morning%20light%20cinematic%20wide%20shot%20warm%20muted%20color%20palette&width=1600&height=900&seq=backdrop-springletter-04&orientation=landscape",
    featured: false,
    popularity: 79,
  },
  {
    id: "star-scavenger",
    title: "星际拾荒者",
    englishTitle: "Orbit Scavengers",
    type: "movie",
    genres: ["科幻", "冒险"],
    region: "美国",
    year: 2025,
    rating: 8.2,
    duration: "141 分钟",
    director: "Ethan Cole",
    cast: ["Miles Archer", "Nora Blake", "Dylan Reyes"],
    synopsis:
      "在废弃轨道站之间捡垃圾为生的三个人，意外打捞到一艘没有编号的军用运输舰。舰上装载的东西足以让整个星区重新洗牌，也足以让他们成为所有人的目标。燃料只剩一格，他们决定赌一次：把这批货送到唯一还愿意听他们说话的星球。",
    poster:
      "https://readdy.ai/api/search-image?query=Epic%20space%20adventure%20movie%20poster%20with%20a%20small%20salvage%20spaceship%20drifting%20past%20a%20colossal%20derelict%20military%20vessel%20deep%20navy%20cosmos%20with%20cyan%20engine%20glow%20and%20distant%20nebula%20cinematic%20poster%20composition%20high%20detail&width=600&height=900&seq=poster-starvscavenger-05&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Vast%20dark%20space%20scene%20with%20a%20tiny%20salvage%20ship%20approaching%20a%20huge%20abandoned%20military%20freighter%20lit%20by%20cyan%20running%20lights%20cinematic%20sci-fi%20film%20still%20epic%20scale%20deep%20navy%20tones&width=1600&height=900&seq=backdrop-starscavenger-05&orientation=landscape",
    featured: true,
    popularity: 95,
  },
  {
    id: "mountain-dream",
    title: "山河旧梦",
    englishTitle: "Old Dreams of Rivers",
    type: "movie",
    genres: ["剧情", "历史"],
    region: "中国",
    year: 2022,
    rating: 9.0,
    duration: "156 分钟",
    director: "谢云阶",
    cast: ["段怀山", "陆知秋", "沈照"],
    synopsis:
      "1937 年，一支迁移中的学校队伍带着两百箱书走完了三千里山路。教书先生、船工的女儿和一个只会写自己名字的少年，在炮火与雨季之间守着这些书。多年以后，少年成了图书馆的管理员，他把那本被水泡皱的名单抄了一遍又一遍。",
    poster:
      "https://readdy.ai/api/search-image?query=Historical%20Chinese%20drama%20film%20poster%20of%20a%20group%20of%20travelers%20carrying%20book%20crates%20along%20a%20misty%20mountain%20road%20in%20the%201930s%20muted%20ink%20wash%20tones%20with%20deep%20navy%20shadows%20and%20soft%20golden%20light%20epic%20cinematic%20composition&width=600&height=900&seq=poster-mountaindream-06&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Epic%20misty%20mountain%20range%20in%20southern%20China%20with%20terraced%20fields%20and%20a%20long%20winding%20road%20at%20dawn%20cinematic%20historical%20film%20still%20deep%20navy%20and%20muted%20green%20tones%20wide%20panorama&width=1600&height=900&seq=backdrop-mountaindream-06&orientation=landscape",
    featured: false,
    popularity: 88,
  },
  {
    id: "foggy-pier",
    title: "迷雾码头",
    englishTitle: "The Foggy Pier",
    type: "movie",
    genres: ["悬疑", "惊悚"],
    region: "英国",
    year: 2024,
    rating: 7.9,
    duration: "109 分钟",
    director: "Oliver Grant",
    cast: ["Harriet Lowe", "Jamie Frost", "Ian Mercer"],
    synopsis:
      "每天凌晨四点，渡轮都会在同一座码头停靠三分钟，而那天早上，船上多了一个不该出现的人。港务员的记录本、灯塔的日志和一段模糊的无线电录音，把调查引向一场被海水掩埋的交易。雾散之前，没有人是清白的。",
    poster:
      "https://readdy.ai/api/search-image?query=Atmospheric%20British%20mystery%20poster%20of%20a%20lone%20figure%20standing%20on%20a%20foggy%20wooden%20pier%20with%20a%20distant%20lighthouse%20beam%20cold%20navy%20blue%20tones%20dense%20fog%20and%20rain%20minimal%20suspenseful%20cinematic%20composition&width=600&height=900&seq=poster-foggypier-07&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Dense%20fog%20over%20an%20old%20harbor%20pier%20with%20a%20single%20lighthouse%20beam%20cutting%20through%20the%20mist%20at%20night%20moody%20desaturated%20navy%20palette%20cinematic%20thriller%20film%20still%20wide%20shot&width=1600&height=900&seq=backdrop-foggypier-07&orientation=landscape",
    featured: false,
    popularity: 71,
  },
  {
    id: "chasing-wind",
    title: "追风少年",
    englishTitle: "Chasing the Wind",
    type: "movie",
    genres: ["青春", "运动"],
    region: "中国",
    year: 2024,
    rating: 8.0,
    duration: "112 分钟",
    director: "韩子澈",
    cast: ["李让", "江一诺", "方野"],
    synopsis:
      "县中学的自行车队只有五个人、三辆能骑的车和一条坑洼的公路。为了拿到省赛的入场券，他们必须在两个月内跑完一段没有人相信他们能跑完的路线。少年们一路摔、一路吵，也一路把自己骑成了风。",
    poster:
      "https://readdy.ai/api/search-image?query=Youth%20sports%20film%20poster%20of%20a%20teenage%20cyclist%20racing%20along%20a%20country%20road%20at%20golden%20hour%20with%20motion%20blur%20and%20dust%20warm%20amber%20sky%20above%20deep%20blue%20mountains%20energetic%20cinematic%20composition%20high%20detail&width=600&height=900&seq=poster-chasingwind-08&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Group%20of%20young%20cyclists%20riding%20along%20a%20mountain%20road%20at%20sunset%20with%20long%20shadows%20and%20warm%20dust%20in%20the%20air%20cinematic%20wide%20shot%20inspiring%20youth%20sports%20film%20still&width=1600&height=900&seq=backdrop-chasingwind-08&orientation=landscape",
    featured: false,
    popularity: 76,
  },
  {
    id: "beyond-dune",
    title: "沙丘之外",
    englishTitle: "Beyond the Dune",
    type: "movie",
    genres: ["科幻", "冒险"],
    region: "美国",
    year: 2025,
    rating: 8.6,
    duration: "149 分钟",
    director: "Marcus Vale",
    cast: ["Aiden Cross", "Leila Haddad", "Tom Reiner"],
    synopsis:
      "沙海尽头的观测站已经失联十一年，当最后一支补给队抵达时，站里的人却像昨天才吃过晚饭。他们守着一种会改变时间流速的矿物，也守着一个不能说出口的约定。补给队的到来，让这个平衡第一次出现裂缝。",
    poster:
      "https://readdy.ai/api/search-image?query=Epic%20desert%20sci-fi%20poster%20featuring%20a%20solitary%20figure%20in%20a%20flowing%20cloak%20walking%20across%20endless%20sand%20dunes%20toward%20a%20distant%20monolithic%20structure%20under%20a%20deep%20blue%20sky%20cinematic%20minimal%20composition%20dramatic%20light&width=600&height=900&seq=poster-beyonddune-09&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Vast%20desert%20landscape%20with%20towering%20sand%20dunes%20and%20a%20strange%20black%20monolith%20at%20the%20horizon%20under%20a%20deep%20navy%20twilight%20sky%20cinematic%20epic%20sci-fi%20film%20still%20wide%20panorama&width=1600&height=900&seq=backdrop-beyonddune-09&orientation=landscape",
    featured: true,
    popularity: 93,
  },
  {
    id: "silent-testimony",
    title: "无声证词",
    englishTitle: "Silent Testimony",
    type: "movie",
    genres: ["悬疑", "犯罪"],
    region: "韩国",
    year: 2023,
    rating: 8.5,
    duration: "121 分钟",
    director: "박정우",
    cast: ["김서연", "이도현", "최민재"],
    synopsis:
      "一位听障清洁工在深夜的写字楼里目睹了一场谋杀，却因为无法作证而被所有人忽略。年轻的检察官找来手语翻译，一点点拼出她看到的那十三秒。当证词终于被听见，真正的危险才刚刚开始。",
    poster:
      "https://readdy.ai/api/search-image?query=Tense%20Korean%20crime%20drama%20poster%20of%20a%20woman%20seen%20through%20a%20rain%20streaked%20office%20window%20at%20night%20with%20cold%20blue%20lighting%20and%20one%20warm%20lamp%20minimal%20high%20contrast%20cinematic%20composition%20subtle%20grain&width=600&height=900&seq=poster-silenttestimony-10&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Empty%20modern%20office%20corridor%20at%20night%20lit%20by%20cold%20blue%20fluorescent%20lights%20with%20long%20reflections%20on%20polished%20floor%20cinematic%20thriller%20film%20still%20wide%20angle%20moody&width=1600&height=900&seq=backdrop-silenttestimony-10&orientation=landscape",
    featured: false,
    popularity: 82,
  },
  {
    id: "homeward-train",
    title: "归途列车",
    englishTitle: "The Homeward Train",
    type: "tv",
    genres: ["剧情", "家庭"],
    region: "中国",
    year: 2025,
    rating: 8.8,
    duration: "全 32 集",
    director: "沈牧之",
    cast: ["陶建成", "温以宁", "梁小满"],
    synopsis:
      "一列从南到北的绿皮车，载着三个家庭二十年的聚散。父亲在车上卖了半辈子盒饭，女儿在同一个站台离开又回来，而那个总坐在最后一节车厢的老人，等的其实是一封永远不会到的信。每一站都有人下车，也总有人重新上车。",
    poster:
      "https://readdy.ai/api/search-image?query=Warm%20Chinese%20family%20drama%20poster%20of%20a%20green%20train%20traveling%20through%20a%20snowy%20countryside%20at%20dusk%20with%20glowing%20windows%20deep%20navy%20sky%20and%20soft%20amber%20light%20nostalgic%20cinematic%20composition&width=600&height=900&seq=poster-homewardtrain-11&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Green%20passenger%20train%20crossing%20a%20snowy%20northern%20landscape%20at%20blue%20hour%20with%20warm%20lit%20windows%20cinematic%20wide%20shot%20nostalgic%20Chinese%20family%20drama%20still%20high%20detail&width=1600&height=900&seq=backdrop-homewardtrain-11&orientation=landscape",
    featured: true,
    popularity: 97,
  },
  {
    id: "dark-river-operation",
    title: "暗河行动",
    englishTitle: "Operation Dark River",
    type: "tv",
    genres: ["刑侦", "动作"],
    region: "中国",
    year: 2024,
    rating: 8.3,
    duration: "全 28 集",
    director: "贺兰川",
    cast: ["闻彻", "顾南亭", "马骥"],
    synopsis:
      "边境线上的暗河从地图上消失了三十年，却从未停止流动。新上任的缉毒队长带着一份残缺的名单进入小镇，发现这里的每个人都在替同一条河保守秘密。他要抓的不只是毒枭，还有那些被河养大的人。",
    poster:
      "https://readdy.ai/api/search-image?query=Gritty%20Chinese%20crime%20series%20poster%20of%20a%20plainclothes%20police%20officer%20standing%20at%20the%20edge%20of%20a%20dark%20river%20at%20night%20with%20distant%20city%20lights%20deep%20navy%20and%20teal%20tones%20cinematic%20high%20contrast&width=600&height=900&seq=poster-darkriver-12&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Dark%20river%20winding%20through%20a%20border%20town%20at%20night%20with%20reflected%20neon%20lights%20and%20mist%20cinematic%20crime%20series%20still%20wide%20shot%20moody%20blue%20palette&width=1600&height=900&seq=backdrop-darkriver-12&orientation=landscape",
    featured: false,
    popularity: 87,
  },
  {
    id: "changan-moon",
    title: "长安月下",
    englishTitle: "Moon Over Chang'an",
    type: "tv",
    genres: ["古装", "爱情"],
    region: "中国",
    year: 2023,
    rating: 8.1,
    duration: "全 40 集",
    director: "柳青崖",
    cast: ["宋知微", "裴照", "云疏"],
    synopsis:
      "她是掌管宫中灯火的司灯女官，他是被贬到长安的年轻画师。一场上元灯会，让两个人的名字被写进同一卷画里。朝堂风云翻覆，灯火明明灭灭，他们能守住的，只有每年那一夜的月亮。",
    poster:
      "https://readdy.ai/api/search-image?query=Elegant%20Chinese%20period%20drama%20poster%20of%20a%20woman%20in%20flowing%20hanfu%20holding%20a%20lantern%20under%20a%20full%20moon%20with%20ancient%20palace%20rooftops%20in%20the%20background%20deep%20indigo%20night%20and%20warm%20gold%20accents%20cinematic%20composition&width=600&height=900&seq=poster-changanmoon-13&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20courtyard%20at%20night%20with%20hundreds%20of%20glowing%20lanterns%20and%20a%20full%20moon%20cinematic%20period%20drama%20still%20deep%20indigo%20sky%20warm%20golden%20light%20wide%20shot&width=1600&height=900&seq=backdrop-changanmoon-13&orientation=landscape",
    featured: false,
    popularity: 80,
  },
  {
    id: "white-labyrinth",
    title: "白色迷城",
    englishTitle: "White Labyrinth",
    type: "tv",
    genres: ["悬疑", "科幻"],
    region: "美国",
    year: 2025,
    rating: 8.7,
    duration: "全 10 集",
    director: "Clara Vaughn",
    cast: ["Evelyn Hart", "Noah Kim", "Grace Doyle"],
    synopsis:
      "一座全年被雪覆盖的研究城里，居民每天醒来都会忘记前一天发生的事。新来的医生发现自己的笔记本上写着同一句话：不要相信第七天的自己。当她顺着线索走进地下层，才明白这座城本身就是一场实验。",
    poster:
      "https://readdy.ai/api/search-image?query=Minimal%20sci-fi%20mystery%20series%20poster%20of%20a%20snow%20covered%20research%20facility%20with%20one%20glowing%20window%20and%20a%20tiny%20silhouette%20in%20the%20foreground%20cold%20white%20and%20deep%20navy%20palette%20high%20contrast%20cinematic&width=600&height=900&seq=poster-whitelabyrinth-14&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Endless%20snow%20plain%20with%20a%20brutalist%20research%20facility%20under%20a%20white%20sky%20cold%20desaturated%20blue%20tones%20cinematic%20sci-fi%20series%20still%20wide%20minimal%20composition&width=1600&height=900&seq=backdrop-whitelabyrinth-14&orientation=landscape",
    featured: false,
    popularity: 89,
  },
  {
    id: "thirty-nine-degrees",
    title: "三十九度",
    englishTitle: "Thirty Nine Degrees",
    type: "tv",
    genres: ["都市", "爱情"],
    region: "中国",
    year: 2024,
    rating: 7.8,
    duration: "全 26 集",
    director: "苏禾",
    cast: ["郑清和", "许知遥", "白一帆"],
    synopsis:
      "在同一栋写字楼里，急诊科医生和气象主播因为一场高温预警认识。一个习惯把情绪压进病历，一个习惯把生活讲成天气。城市连续三十九天高温，他们的关系也在第三十九天走到了必须做决定的路口。",
    poster:
      "https://readdy.ai/api/search-image?query=Modern%20urban%20romance%20series%20poster%20of%20a%20couple%20standing%20on%20a%20city%20rooftop%20at%20dusk%20with%20glass%20towers%20and%20a%20hazy%20warm%20orange%20sky%20above%20deep%20blue%20shadows%20clean%20cinematic%20composition&width=600&height=900&seq=poster-39degrees-15&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=City%20skyline%20at%20sunset%20seen%20from%20a%20rooftop%20with%20warm%20haze%20and%20blue%20shadows%20in%20the%20streets%20below%20cinematic%20urban%20drama%20still%20wide%20shot%20modern%20architecture&width=1600&height=900&seq=backdrop-39degrees-15&orientation=landscape",
    featured: false,
    popularity: 74,
  },
  {
    id: "dawn-on-rails",
    title: "铁轨上的黎明",
    englishTitle: "Dawn on the Rails",
    type: "tv",
    genres: ["年代", "剧情"],
    region: "中国",
    year: 2022,
    rating: 9.1,
    duration: "全 36 集",
    director: "欧阳戍",
    cast: ["程铁生", "柳素云", "孟广林"],
    synopsis:
      "从蒸汽机车到电力动车，三代铁路人守着同一条线。祖父在抢险中失去了一条腿，父亲把一生写在调度表上，孙子则想离开这座只会经过火车的城。一次线路改造，让三代人第一次坐下来，把没说完的话说完了。",
    poster:
      "https://readdy.ai/api/search-image?query=Nostalgic%20Chinese%20period%20drama%20poster%20of%20an%20old%20steam%20locomotive%20at%20dawn%20with%20a%20railway%20worker%20silhouette%20and%20warm%20orange%20sunrise%20breaking%20over%20deep%20blue%20hills%20cinematic%20epic%20composition&width=600&height=900&seq=poster-dawnrails-16&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Steam%20train%20crossing%20a%20stone%20viaduct%20at%20sunrise%20with%20mist%20in%20the%20valley%20cinematic%20period%20drama%20still%20warm%20golden%20light%20against%20deep%20blue%20morning%20shadows%20wide%20shot&width=1600&height=900&seq=backdrop-dawnrails-16&orientation=landscape",
    featured: false,
    popularity: 86,
  },
  {
    id: "midnight-diner",
    title: "深夜食堂物语",
    englishTitle: "Tales of the Midnight Diner",
    type: "tv",
    genres: ["治愈", "美食"],
    region: "日本",
    year: 2023,
    rating: 8.4,
    duration: "全 12 集",
    director: "中村凉",
    cast: ["大岛修", "森川绫", "石井旬"],
    synopsis:
      "巷子深处的小店只在午夜开门，菜单上只有一道菜，老板却愿意为每位客人做任何想吃的。加班到末班车后的上班族、刚被解约的乐手、带着孩子来的单亲妈妈，他们把故事留在碗底，把明天带走。",
    poster:
      "https://readdy.ai/api/search-image?query=Cozy%20Japanese%20midnight%20diner%20series%20poster%20of%20a%20small%20warm%20lantern%20lit%20shop%20in%20a%20narrow%20alley%20with%20steam%20rising%20from%20a%20bowl%20deep%20navy%20night%20and%20amber%20glow%20cinematic%20intimate%20composition&width=600&height=900&seq=poster-midnightdiner-17&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Narrow%20Tokyo%20alley%20at%20midnight%20with%20a%20small%20glowing%20diner%20entrance%20warm%20light%20spilling%20onto%20wet%20stones%20cinematic%20series%20still%20cozy%20atmosphere%20deep%20blue%20night&width=1600&height=900&seq=backdrop-midnightdiner-17&orientation=landscape",
    featured: false,
    popularity: 78,
  },
  {
    id: "orion-project",
    title: "猎户座计划",
    englishTitle: "The Orion Project",
    type: "tv",
    genres: ["科幻", "惊悚"],
    region: "英国",
    year: 2025,
    rating: 8.0,
    duration: "全 8 集",
    director: "Ruth Calloway",
    cast: ["Daniel Pryce", "Sofia Lang", "Ben Osei"],
    synopsis:
      "射电望远镜接收到一段来自猎户座的规律脉冲，破译后是一份日期表，每一格都对应地球上的一次事故。研究团队试图阻止第一个日期，却发现自己的名字早已出现在名单的最后。",
    poster:
      "https://readdy.ai/api/search-image?query=British%20sci-fi%20thriller%20series%20poster%20of%20a%20huge%20radio%20telescope%20dish%20silhouetted%20against%20a%20starry%20navy%20sky%20with%20faint%20cyan%20signal%20rings%20cinematic%20minimal%20high%20contrast%20composition&width=600&height=900&seq=poster-orionproject-18&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Radio%20telescope%20array%20in%20a%20remote%20highland%20at%20night%20under%20the%20milky%20way%20cinematic%20sci-fi%20series%20still%20deep%20navy%20sky%20wide%20epic%20scale&width=1600&height=900&seq=backdrop-orionproject-18&orientation=landscape",
    featured: false,
    popularity: 83,
  },
  {
    id: "double-edged-lawyer",
    title: "双面律师",
    englishTitle: "The Double-Edged Lawyer",
    type: "tv",
    genres: ["律政", "悬疑"],
    region: "韩国",
    year: 2024,
    rating: 8.2,
    duration: "全 16 集",
    director: "정하람",
    cast: ["한지우", "오세훈", "윤나경"],
    synopsis:
      "胜诉率百分之百的明星律师接下一桩看起来毫无希望的案子，被告是他二十年前的同窗。随着调查深入，他发现所有对自己有利的证据，都来自一个不该存在的证人。法庭之上，他要赢的到底是案子，还是自己。",
    poster:
      "https://readdy.ai/api/search-image?query=Korean%20legal%20thriller%20series%20poster%20of%20a%20confident%20lawyer%20holding%20a%20document%20in%20a%20dark%20courtroom%20with%20dramatic%20side%20lighting%20deep%20navy%20tones%20and%20cold%20blue%20highlights%20cinematic%20portrait&width=600&height=900&seq=poster-doublelawyer-19&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Empty%20courtroom%20at%20night%20with%20rows%20of%20wooden%20benches%20and%20a%20single%20overhead%20light%20cinematic%20legal%20drama%20still%20dramatic%20shadows%20deep%20blue%20palette%20wide%20shot&width=1600&height=900&seq=backdrop-doublelawyer-19&orientation=landscape",
    featured: false,
    popularity: 81,
  },
  {
    id: "wind-over-nanyang",
    title: "风起南洋",
    englishTitle: "Wind Over Nanyang",
    type: "tv",
    genres: ["历史", "冒险"],
    region: "新加坡",
    year: 2023,
    rating: 8.5,
    duration: "全 30 集",
    director: "陈启明",
    cast: ["林致远", "周婉宁", "黄启山"],
    synopsis:
      "上世纪三十年代，一艘从福建出发的商船在南洋遭遇风暴，船上的人从此散落在不同的港口。有人成了码头帮会的账房，有人开起了第一家杂货铺，而那张被海水泡烂的船契，最终把他们的孩子又聚到了同一片海上。",
    poster:
      "https://readdy.ai/api/search-image?query=Historical%20maritime%20drama%20poster%20of%20a%20wooden%20merchant%20ship%20sailing%20through%20a%20tropical%20storm%20with%20dramatic%20waves%20and%20deep%20navy%20clouds%20warm%20lantern%20light%20on%20deck%20cinematic%20epic%20composition&width=600&height=900&seq=poster-nanyangwind-20&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Southeast%20Asian%20harbor%20in%20the%201930s%20with%20wooden%20ships%20and%20colonial%20shophouses%20at%20dusk%20cinematic%20historical%20drama%20still%20warm%20amber%20lights%20against%20deep%20blue%20sky%20wide%20shot&width=1600&height=900&seq=backdrop-nanyangwind-20&orientation=landscape",
    featured: false,
    popularity: 85,
  },
];

export const genreOptions = [
  "全部",
  "动作",
  "爱情",
  "科幻",
  "悬疑",
  "犯罪",
  "剧情",
  "古装",
  "冒险",
  "治愈",
  "青春",
  "历史",
  "刑侦",
  "都市",
  "律政",
  "家庭",
  "美食",
  "运动",
] as const;

export const regionOptions = [
  "全部",
  "中国",
  "中国香港",
  "美国",
  "日本",
  "韩国",
  "英国",
  "新加坡",
] as const;

export const yearOptions = ["全部", "2025", "2024", "2023", "2022"] as const;

export const getMovieById = (id: string | undefined) =>
  movies.find((movie) => movie.id === id);

export const getRelatedMovies = (movie: Movie, limit = 4) => {
  const sameGenre = movies.filter(
    (item) =>
      item.id !== movie.id && item.genres.some((g) => movie.genres.includes(g)),
  );
  const others = movies.filter(
    (item) => item.id !== movie.id && !sameGenre.includes(item),
  );
  return [...sameGenre, ...others].slice(0, limit);
};

export const getHotMovies = (limit = 8) =>
  [...movies]
    .filter((movie) => movie.type === "movie")
    .sort((a, b) => b.popularity - a.popularity)
    .slice(0, limit);

export const getHotSeries = (limit = 8) =>
  [...movies]
    .filter((movie) => movie.type === "tv")
    .sort((a, b) => b.popularity - a.popularity)
    .slice(0, limit);